// Port of api/fuel/app/classes/filter/search/games/filters/query/other/tagfamilies.php
import F from 'offline/filter/constants'
import DB from 'offline/db'
import Util from 'offline/util'
export default {
	name: 'other.tagfamilies',
	priority: 78,
	require: function(config, filter) {
		return config.ownerType === F.OWNER_USER && filter.tagfamilies && filter.tagfamilies.length > 0
	},
	run: function(config, filter, data, query) {
		var include = [], exclude = []
		for (var i = 0; i < filter.tagfamilies.length; i++) {
			var tf = filter.tagfamilies[i]
			if (tf < 0) exclude.push(-tf)
			else include.push(tf)
		}
		if (include.length) {
			var games = DB.query('SELECT DISTINCT ta.game_id AS g FROM tag_attach ta JOIN tag t ON ta.tag_id = t.tag_id WHERE t.family_id IN(' + Util.in(include) + ') AND ta.game_id > 0')
			var ids = Util.pluck(games, 'g')
			if (ids.length) query.where('g.game_id', 'in', ids)
			else query.where('g.game_id', '=', 0)
		}
		if (exclude.length) {
			var exGames = DB.query('SELECT DISTINCT ta.game_id AS g FROM tag_attach ta JOIN tag t ON ta.tag_id = t.tag_id WHERE t.family_id IN(' + Util.in(exclude) + ') AND ta.game_id > 0')
			var exIds = Util.pluck(exGames, 'g')
			if (exIds.length) query.where('g.game_id', 'not in', exIds)
		}
	}
}
